import { render, staticRenderFns } from "./PopularUpdate.vue?vue&type=template&id=e70ddb06&scoped=true&"
import script from "./PopularUpdate.vue?vue&type=script&lang=js&"
export * from "./PopularUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70ddb06",
  null
  
)

export default component.exports